export default __webpack_public_path__ + "static/media/fireFighter1.be861592.jpg";